module.exports = __webpack_public_path__ + "img/TheUnitedKingdom.5f5d5615.png";